module.exports = __webpack_public_path__ + "img/hardyDrillArms1.9ceb5eef.png";